(function () {
  function buildMark(color) {
    return (
      '<span style="display:inline-flex;align-items:center;gap:0.4em;white-space:nowrap;">' +
      '<svg viewBox="0 0 100 100" style="width:1.05em;height:1.05em;flex:none;" aria-hidden="true" focusable="false">' +
      '<g transform="rotate(-38 50 50)"><circle cx="50" cy="50" r="36" fill="none" stroke="' + color + '" stroke-width="7" stroke-dasharray="179.07 47.12" stroke-linecap="round"/></g>' +
      '<circle cx="40" cy="38" r="10" fill="' + color + '"/>' +
      '</svg>' +
      '<span style="font-weight:800;letter-spacing:0.05em;">ORIVON</span>' +
      '</span>'
    );
  }
  function apply() {
    document.querySelectorAll('.logo-text').forEach(function (el) {
      if (el.dataset.orivonMark === '1') return;
      var isDarkVariant = el.classList.contains('dark:inline-block');
      el.innerHTML = buildMark(isDarkVariant ? '#FFFFFF' : '#9C1938');
      el.dataset.orivonMark = '1';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
